import * as Sentry from '@sentry/react';
import { call, take, race, delay } from 'redux-saga/effects';
import { SFrameManager } from 'features/e2ee/SFrameManager';
import { sframeInitialized } from 'features/e2ee/actions';
import { logger } from 'utils/logger';

const SFRAME_INIT_TIMEOUT_MS = 20000;

// Avoid race conditions. SFrame initialization started on roomJoined event

export function* refineSframeStatus() {
  const isSframeInitialized: boolean = yield call(SFrameManager.isInitialized);

  if (!isSframeInitialized) {
    const { timeout } = yield race({
      initialized: take(sframeInitialized),
      timeout: delay(SFRAME_INIT_TIMEOUT_MS),
    });

    if (timeout) {
      logger
        .remote({ system: true, capture: 'e2ee' })
        .error('[E2EE] Timed out waiting for SFrame initialization');
      Sentry.captureMessage('[E2EE] SFrame initialization timed out');
    }
  }
}
